export const ROLE_COMERCIAL = 'ROLE_COMERCIAL';
export const ROLE_SISTEMA = 'ROLE_SISTEMA';
export const ROLE_EXECUTIVO = 'ROLE_EXECUTIVO';
export const ROLE_INTERMEDIARIO = 'ROLE_INTERMEDIARIO';
export const ROLE_PLATAFORMA = 'ROLE_PLATAFORMA';
export const ROLE_PERMISSAO_CRIAR_VENDA = 'ROLE_PERMISSAO_CRIAR_VENDA';
export const ROLE_COMERCIAL_ESPECIAL = 'ROLE_COMERCIAL_ESPECIAL';
export const ROLE_PERMISSAO_CANCELAR_VENDA = 'ROLE_PERMISSAO_CANCELAR_VENDA'
export const ROLE_PERMISSAO_INATIVAR_PROFISSIONAL = 'ROLE_PERMISSAO_INATIVAR_PROFISSIONAL'
export const ROLE_PERMISSAO_VISUALIZAR_PERFIL_PUBLICO = 'ROLE_PERMISSAO_VISUALIZAR_PERFIL_PUBLICO'
export const ROLE_PERMISSAO_CONFIGURAR_IA = 'ROLE_PERMISSAO_CONFIGURAR_IA'
export const ROLE_GERENCIAR_ENTIDADE = 'ROLE_GERENCIAR_ENTIDADE'
export const ROLE_PERMISSAO_EDITAR_PROFISSIONAL = 'ROLE_PERMISSAO_EDITAR_PROFISSIONAL'
export const ROLE_PERMISSAO_CRIAR_PROFISSIONAL = 'ROLE_PERMISSAO_CRIAR_PROFISSIONAL'
export const ROLE_PERMISSAO_ALTERAR_QUANTIDADE_PROFISSIONAIS='ROLE_PERMISSAO_ALTERAR_QUANTIDADE_PROFISSIONAIS'
export const ROLE_PERIODO_ATENDIMENTO_MODIFICADO_UPDATE='ROLE_PERIODO_ATENDIMENTO_MODIFICADO_UPDATE'
